import React from "react";
import { CookiesProvider } from "react-cookie";
import "./App.css";
import Home from "./Home";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AllOrgsList from "./AllOrgsList";
import EventList from "./EventList";
import MyEvents from "./MyEvents";
import OrgEdit from "./OrgEdit";
import OrgRead from "./OrgRead";
import ContactEdit from "./ContactEdit";
import EventEdit from "./EventEdit";
import EventRead from "./EventRead";
import MyCallLogs from "./MyCallLogs";
import CallLogEdit from "./CallLogEdit";
import ContactList from "./ContactList";
import ContactRead from "./ContactRead";
import ManagerReports from "./ManagerReports";
import ManagerDashboard from "./ManagerDashboard";

function App() {
    return (
      <CookiesProvider>
        <Router>
          <Switch>
            <Route path="/" exact><Home/></Route>
            <Route path="/organizations" exact><AllOrgsList/></Route>
            <Route path="/events" exact><EventList/></Route>
            <Route path="/myoutreach" exact><MyEvents/></Route>
            <Route path="/organizations/:id" render={props => <OrgEdit {...props} />} />
            <Route path="/organization/read/:id"  render={props => <OrgRead {...props} />} />
            <Route path="/contact/read/:id" render={props => <ContactRead {...props} />} />
            <Route path="/contact/:id" render={props => <ContactEdit {...props} />} />
            <Route path="/events/:id" render={props => <EventEdit {...props} />} />
            <Route path="/event/read/:id" render={props => <EventRead {...props} />} />
            <Route path="/calllog/:id" render={props => <CallLogEdit {...props} />} />
            <Route path="/contacts" exact><ContactList/></Route>
            <Route path="/manager-reports" exact><ManagerReports/></Route>
            <Route path="/manager-dashboard" exact><ManagerDashboard/></Route>
            <Route path="/calllogs" exact render={props => <MyCallLogs {...props} />} />
          </Switch>
        </Router>
      </CookiesProvider>
    );
  }

export default App;